var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 32,
    viewBox: "0 0 39 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V14.6715C0 17.704 1.24188 20.6787 3.43682 22.8159C5.574 24.9242 8.40433 26.0505 11.3502 26.0217C17.3863 25.9061 22.296 20.9097 22.296 14.8736V7.94224H27.87C29.7762 7.94224 31.5379 8.69314 32.8375 10.0794C34.166 11.4368 34.8303 13.2563 34.7725 15.1336C34.6281 18.8014 31.4512 21.7762 27.6679 21.7762H24.0578C22.787 21.7762 21.7473 22.8159 21.7473 24.0866V31.9422H22.2383C24.2888 31.9422 25.9639 30.2671 25.9639 28.2166V25.9639H27.6679C30.7003 25.9639 33.6751 24.722 35.8123 22.5271C37.9206 20.3899 39.0469 17.5884 39.018 14.6426C38.9025 8.86643 34.1949 4.04332 28.3899 3.75451V3.72563H27.87H27.8411L20.3899 3.75451C19.1191 3.75451 18.0794 4.79422 18.0794 6.06498V14.7004C18.0794 18.4838 15.0758 21.6606 11.4079 21.8051C9.5018 21.8917 7.71119 21.1986 6.32491 19.87C4.96751 18.5415 4.18772 16.7798 4.18772 14.8736V3.72563C4.2166 1.67509 2.54152 0 0.490975 0H0Z",
    fill: "url(#paint0_linear_339_7768)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_7768",
    x1: 0,
    y1: 15.9942,
    x2: 38.9926,
    y2: 15.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71B790"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008C15"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.88f0d27bfe9aa559cbbcf31a7e64002a.svg";
export { ForwardRef as ReactComponent };